// Country name aliases across data sources (LocationIQ, various travel/hotel APIs, user input,
// etc.) that don't match the canonical `country` field in countryISOCodes.json — keyed by the
// alias, valued by the canonical name. Shared (no React/scss deps) so it can be imported by both
// UI-heavy modules (exploreCommon.tsx) and lean ones (components/common/Flag.tsx) without pulling
// in unrelated bundle weight.
export const COUNTRY_NAME_ALIASES: Record<string, string> = {
	"United States of America": "United States",
	USA: "United States",
	Russia: "Russian Federation",
	Turkey: "Türkiye",
	Czechia: "Czech Republic",
	Fiji: "Fiji Islands",
	"North Macedonia": "Macedonia",
	"Democratic Republic of Congo": "Democratic Republic of the Congo",
	"DR Congo": "Democratic Republic of the Congo",
	"Ivory Coast": "Cote D'Ivoire (Ivory Coast)",
	"Côte d'Ivoire": "Cote D'Ivoire (Ivory Coast)",
	"Cote d'Ivoire": "Cote D'Ivoire (Ivory Coast)",
	"Timor-Leste": "East Timor",
	UAE: "United Arab Emirates",
	"Bosnia & Herzegovina": "Bosnia and Herzegovina",
	"St. Lucia": "Saint Lucia",
	"St Lucia": "Saint Lucia",
	Curacao: "Curaçao",
};

export const normalizeCountry = (name: string): string => COUNTRY_NAME_ALIASES[name] ?? name;
